import * as React from 'react';

// tslint:disable:max-line-length
export const CommerceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M15 4H1c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm-3.9 10H4.9c-.4-1.4-1.5-2.5-2.9-2.9V8.9C3.4 8.5 4.5 7.4 4.9 6h6.3c.4 1.4 1.5 2.5 2.9 2.9v2.3c-1.5.3-2.6 1.4-3 2.8z" />
      <circle cx="8" cy="10" r="2" />
      <path d="M2 0h12v2H2z" />
    </g>
  </svg>
);
